import Swal from 'sweetalert2';

const showToast = (icon, title, timer = 3000, position = 'top-end') => { // Default timer and position
  return Swal.fire({
    toast: true,
    icon: icon,
    title: title,
    position: position,
    timer: timer,
    showConfirmButton: false,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });
};

const showSuccessToast = (title, timer, position) => {
    return showToast('success', title, timer, position)
}
const showErrorToast = (title, timer, position) => {
    return showToast('error', title, timer, position)
}
const showWarningToast = (title, timer, position) => {
    return showToast('warning', title, timer, position)
}
const showInfoToast = (title, timer, position) => {
    return showToast('info', title, timer, position)
}
const showQuestionToast = (title, timer, position) => {
    return showToast('question', title, timer, position)
}

export { showToast, showSuccessToast, showErrorToast, showWarningToast, showInfoToast, showQuestionToast };